/**
 * Minimal UI Kit — Base theme factory
 * Source: https://github.com/minimal-ui-kit/material-kit-react (free kit, v6.x)
 *
 * Creates the Minimal base theme. Palette is injected separately so the CCS
 * brand colours slot in without touching any other Minimal token.
 */

import { createTheme } from "@mui/material/styles";
import type { Theme, ThemeOptions } from "@mui/material/styles";
import { minimalTypography } from "./typography";
import { minimalShadows } from "./shadows";
import { minimalComponents } from "./overrides";

export interface MinimalThemeOptions {
  palette?: ThemeOptions["palette"];
}

/**
 * Build the Minimal base theme, optionally overriding the palette.
 * The returned theme has Minimal's typography, shadows, shape, and component
 * overrides — all unchanged from the free kit.
 */
export function createMinimalTheme(options: MinimalThemeOptions = {}): Theme {
  const base = createTheme({
    shape: {
      borderRadius: 8,
    },
    typography: minimalTypography,
    shadows: minimalShadows,
    palette: {
      ...options.palette,
      grey: {
        100: "#F9FAFB",
        200: "#F4F6F8",
        300: "#DFE3E8",
        400: "#C4CDD5",
        500: "#919EAB",
        600: "#637381",
        700: "#454F5B",
        800: "#212B36",
        900: "#161C24",
      },
    },
  });

  return createTheme(base, {
    components: minimalComponents(base),
  });
}
